import { useParams } from "react-router";

export default function ArticlesCategory() {
    const { category } = useParams();
    return(
        <div className="ArticlesCategory">
            {category}
        </div>
    );
}